export default __webpack_public_path__ + "static/media/kiit2.49cc7efd.png";